const APP_BACK_TRANSITION_TTL_MS = 800;

let appBackTransitionUntil = 0;

export function markAppBackTransition() {
  appBackTransitionUntil = Date.now() + APP_BACK_TRANSITION_TTL_MS;
}

export function consumeAppBackTransition(): boolean {
  if (Date.now() > appBackTransitionUntil) {
    appBackTransitionUntil = 0;
    return false;
  }

  appBackTransitionUntil = 0;
  return true;
}
